export function articleReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_ARTICLE":            
        case "UPDATE_ARTICLE":
            let list = Object.assign({}, state);
            list[payload.article_id] = payload
        
            return list
        
        case "GET_ARTICLES":

            return payload
            
        default:
            return state;
    }
    
}